<template>
  <v-layout v-if="this.$route.path !== '/tomamu/top'" row wrap class="root">
    <v-flex xs3>
      <img src="/images/logo.png" />
    </v-flex>
    <v-flex xs9>
      <v-layout column justify-center class="logo-type-container">
        <img src="/images/logoType.png" />
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'CommonHeader'
  }
</script>

<style lang="scss" scoped>
img {
  width: 100%;
}
.root {
  padding: 16px;
}
.logo-type-container {
  height: 100%;
  margin-left: 8px;
}
</style>
